import { createAction } from '@reduxjs/toolkit';
import { EmployeeOption } from './employees.types';

export const clearEmployeesAction = createAction('employees/clear');
export const clearMentionedEmployeesAction = createAction('employees/clearMentionedItems');
export const setMentionedEmployeesItemsAction = createAction<EmployeeOption>('employees/setMentionedItemsAction');
